const categories = [
    {
        id: 1,
        name: 'The Chai Lovers',
        backendValue: 'The Chai Lovers',
        image: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772168830/cteories28_AM_bducx3.webp', // Desktop image
        mobileImage: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772169601/mobcat_ej6kzs.webp', // <--- ADDED: Mobile specific image
        isComingSoon: false 
    },
    {
        id: 2,
        name: 'Spice Gift Boxes',
        backendValue: 'Spice Gift Boxes',
        image: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772177811/ChacategM_ng5n72.webp',
        mobileImage: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772175512/soon_PM_plgilw.webp', 
        isComingSoon: true 
    },
    {
        id: 3,
        name: 'Whole Spices',
        backendValue: 'Whole Spices',
        image: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772177088/Chardgdg_kjwwzj.webp',
        mobileImage: 'https://res.cloudinary.com/dit7yymcl/image/upload/v1772177088/hjghj_ueiqle.webp', 
        isComingSoon: true 
    }
];

export default categories;